export default __webpack_public_path__ + "static/media/im3.8d24fda8.jpg";